<template>
	<v-container fluid>
		<v-expansion-panels class="mb-6" :value="0">
			<v-expansion-panel>
				<v-expansion-panel-header disable-icon-rotate>
					Critérios de pesquisa
					<template v-slot:actions>
						<v-icon>search</v-icon>
					</template>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-layout wrap>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.ano_lectivo" label="Ano Lectivo" :items="AnosLectivos" :rules="[inputRules.required]"></v-select>
						</v-flex>
						<v-flex xs12 sm8 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.concelho_id" label="Concelho" :items="Concelhos" :clearable="Concelhos.length > 1" :readonly="Concelhos.length == 1"></v-select>
						</v-flex>
						<v-flex xs12 sm4 md4 px-1>
							<v-text-field v-model="Pesquisa.Criterios.escola_nome" label="Nome da escola" clearable></v-text-field>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.turma_ano" label="Ano" :items="AnosCurriculares" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-text-field v-model="Pesquisa.Criterios.turma_designacao" label="Turma" clearable></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_sexo" label="Sexo" :items="Sexos" clearable></v-select>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_transferido" label="Transferido?" :items="NaoSim" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_nee" label="NEE?" :items="NaoSim" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_feo" label="FEO?" :items="NaoSim" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_medida_apoio" label="Medida de apoio?" :items="NaoSim" clearable></v-select>
						</v-flex>
					</v-layout>

					<div class="my-8">
						<v-layout d-flex justify-end>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text color="primary" v-on="on" @click="pesquisar">
										<v-icon left>search</v-icon>
										Pesquisar
									</v-btn>
								</template>
								<span>Pesquisar</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text color="primary" v-on="on" @click="limpar">
										<v-icon left>clear</v-icon>
										Limpar
									</v-btn>
								</template>
								<span>Limpar critérios de pesquisa</span>
							</v-tooltip>
						</v-layout>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-card v-if="Pesquisa.estado == 2" class="pa-5">
			<v-row no-gutters class="py-5">
				<v-col cols="12" sm="4">
					<v-simple-table>
						<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left"></th>
								<th class="text-left">#</th>
								<th class="text-left"></th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong>Alunos/as</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos }}</td>
								<td></td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>

					<br/>
					
					<v-simple-table>
						<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">
									
								</th>
								<th class="text-left">
									#
								</th>
								<th class="text-left">
									%
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong>Sexo masculino</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos_masculino }} </td>
								<td>{{ Pesquisa.DadosAgregados.alunos_masculino / Pesquisa.DadosAgregados.alunos | percentage(1, true) }}</td>
							</tr>
							<tr>
								<td><strong>Sexo feminino</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos_feminino }} </td>
								<td>{{ Pesquisa.DadosAgregados.alunos_feminino / Pesquisa.DadosAgregados.alunos | percentage(1, true) }}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
				</v-col>

				<v-col cols="12" sm="4">
					<apexchart type="pie" :options="ChartSexo.options" :series="ChartSexo.series"></apexchart>
				</v-col>

				<v-col cols="12" sm="4">
					<v-simple-table>
						<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">
									
								</th>
								<th class="text-left">
									#
								</th>
								<th class="text-left">
									%
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong>Transferidos</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos_transferidos }} </td>
								<td>{{ Pesquisa.DadosAgregados.alunos_transferidos / Pesquisa.DadosAgregados.alunos | percentage(1, true) }}</td>
							</tr>
							<tr>
								<td><strong>NEE</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos_nee }} </td>
								<td>{{ Pesquisa.DadosAgregados.alunos_nee / Pesquisa.DadosAgregados.alunos | percentage(1, true) }}</td>
							</tr>
							<tr>
								<td><strong>Fora da escolaridade obrigatória</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos_feo }} </td>
								<td>{{ Pesquisa.DadosAgregados.alunos_feo / Pesquisa.DadosAgregados.alunos | percentage(1, true) }}</td>
							</tr>
							<tr>
								<td><strong>Integrados em medidas de apoio</strong></td>
								<td>{{ Pesquisa.DadosAgregados.alunos_medida_apoio }} </td>
								<td>{{ Pesquisa.DadosAgregados.alunos_medida_apoio / Pesquisa.DadosAgregados.alunos | percentage(1, true) }}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
				</v-col>
			</v-row>

			<v-row no-gutters class="py-5 d-none d-sm-flex">
				<v-container>
					<apexchart id="chart-escola-ano" type="treemap" :options="ChartAno.options" :series="ChartAno.series"></apexchart>
				</v-container>
			</v-row>
		</v-card>
	</v-container>
</template>

<script>
    import Vue from 'vue'
	import StaticData from '@/data/static-data.js';
	Vue.use(StaticData);

	import UserService from '@/services/user.service';
	const userService = new UserService();

	import VueApexCharts from 'vue-apexcharts'
	Vue.use(VueApexCharts)

	export default {
		components: {
			apexchart: VueApexCharts
		},
		data: () => ({
			AnosLectivos: StaticData.AnosLectivos,
			Concelhos: [], // to be loaded on created
			AnosCurriculares: StaticData.AnosCurriculares,
			Sexos: StaticData.Sexos,
			NaoSim: StaticData.NaoSim,
			Pesquisa: {
				estado: 0, /* 0 - Por efectuar; 1 - Em processamento; 2 - Efectuada*/
				Criterios: {
					ano_lectivo: StaticData.AnoLectivoActual
				},
				Resultados: [],
				DadosAgregados: {}
			},
			ChartSexo: {
				options: {
					chart: {
						id: 'chart-genero',
						// width: "100%",
						// height: 400
					},
					labels: ['Masculino', 'Feminino'],
					title: {
						text: 'N.º de alunos/as, por género',
						align: 'center'
					},
					legend: {
						position: 'bottom'
					}
				},
				series: [{
					data: []
				}]
			},
			// ChartIdade: {
			// 	options: {
			// 		chart: {
			// 			id: 'chart-idade',
			// 			width: 380
			// 		},
			// 	},
			// 	series: [{
			// 		type: 'boxPlot',
			// 		data: []
			// 	}]
			// },
			ChartAno: {
				options: {
					chart: {
						id: 'chart-escola-ano',
						type: 'treemap'
					},
					legend: {
						show: true
					},
					title: {
						text: 'N.º de alunos/as, por escola e ano',
						align: 'center'
					}
				},
				series: [{
					data: []
				}]
			},
            inputRules: {
                required: value => !!value || 'Campo obrigatório'
            }
		}),

		created () {
			this.loadConcelhos();
		},

		mounted () {
		},

		computed: {
			QueryPesquisa: function () {
				let queryPesquisa = 
					(this.Pesquisa.Criterios.ano_lectivo ? `&ano_lectivo_id=${this.Pesquisa.Criterios.ano_lectivo}` : '') +
					(this.Pesquisa.Criterios.concelho_id ? `&concelho_id=${this.Pesquisa.Criterios.concelho_id}` : '') +
					(this.Pesquisa.Criterios.escola_nome ? `&escola_nome=${this.Pesquisa.Criterios.escola_nome}` : '') +
					(this.Pesquisa.Criterios.turma_ano ? `&turma_ano=${this.Pesquisa.Criterios.turma_ano}` : '') +
					(this.Pesquisa.Criterios.turma_designacao ? `&turma_designacao=${this.Pesquisa.Criterios.turma_designacao}` : '') +
					(this.Pesquisa.Criterios.aluno_sexo ? `&aluno_sexo=${this.Pesquisa.Criterios.aluno_sexo}` : '') +
					(this.Pesquisa.Criterios.aluno_transferido ? `&aluno_transferido=${this.Pesquisa.Criterios.aluno_transferido}` : '') +
					(this.Pesquisa.Criterios.aluno_nee ? `&aluno_nee=${this.Pesquisa.Criterios.aluno_nee}` : '') +
					(this.Pesquisa.Criterios.aluno_feo ? `&aluno_feo=${this.Pesquisa.Criterios.aluno_feo}` : '') +
					(this.Pesquisa.Criterios.aluno_medida_apoio ? `&aluno_medida_apoio=${this.Pesquisa.Criterios.aluno_medida_apoio}` : '')
				;

				if (queryPesquisa.length > 0) {
					queryPesquisa = queryPesquisa.replace('&', '?');
				}

				return queryPesquisa;
			}
        },

        methods: {
			loadConcelhos () {
				this.isLoading = true;

				var currentUser = userService.getUserId();

				this.$http.get(process.env.VUE_APP_API_ROOT + `/concelho/?utilizador=${currentUser}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    var arrayConcelhos = [];
                    data.forEach (item => {
                        arrayConcelhos.push({ value: item.id, text: item.nome});
                    });
					this.Concelhos = arrayConcelhos;
					
					if (arrayConcelhos.length === 1) {
						this.Pesquisa.Criterios.concelho_id = arrayConcelhos[0].value;
					}

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
			obterDadosAgregados () {
				let initialValues = { alunos: 0, alunos_masculino: 0, alunos_feminino: 0, alunos_nee: 0, alunos_medida_apoio: 0, alunos_transferidos: 0, alunos_feo: 0};

				var dadosAgregados = this.Pesquisa.Resultados.reduce((accumulator, current) => {
					accumulator.alunos++;

					if (current.aluno_sexo == 'M') {
						accumulator.alunos_masculino++;
					}
					else if (current.aluno_sexo == 'F') {
						accumulator.alunos_feminino++;
					}

					if (current.aluno_nee == 1) {
						accumulator.alunos_nee++;
					}
					if (current.aluno_medida_apoio == 1) {
						accumulator.alunos_medida_apoio++;
					}
					if (current.aluno_transferido == 1) {
						accumulator.alunos_transferidos++;
					}
					if (current.aluno_feo == 1) {
						accumulator.alunos_feo++;
					}

					return accumulator;
				}, initialValues);

				return dadosAgregados;
			},
			configurarGraficoSexo () {
				this.ChartSexo.series = [this.Pesquisa.DadosAgregados.alunos_masculino, this.Pesquisa.DadosAgregados.alunos_feminino];
			},
			// configurarGraficoIdade () {
			// 	var groupByAno = this.Pesquisa.Resultados.reduce((x, y) => {
			// 		(x[y.turma_ano] = x[y.turma_ano] || []).push(y);
			// 		return x;
			// 	}, {});

			// 	console.log(groupByAno);
			// 	// this.ChartIdade.series = // TODO
			// },
			configurarGraficoAno () {
				let series = [];

				var groupByEscola = this.Pesquisa.Resultados.reduce((x, y) => {
					(x[y.escola_nome] = x[y.escola_nome] || []).push(y);
					return x;
				}, {});
				
				Object.keys(groupByEscola).forEach(escola => {
					let groupByAno = groupByEscola[escola].reduce((x, y) => {
						(x[y.turma_ano] = x[y.turma_ano] || []).push(y);
						return x;
					}, {});

					series.push(
						{
							name: escola,
							data: [
								{ x: '1.º ano', y: groupByAno['1'] ? groupByAno['1'].length : 0 },
								{ x: '2.º ano', y: groupByAno['2'] ? groupByAno['2'].length : 0 },
								{ x: '3.º ano', y: groupByAno['3'] ? groupByAno['3'].length : 0 },
								{ x: '4.º ano', y: groupByAno['4'] ? groupByAno['4'].length : 0 }
							]
						}
					)
				})
				// console.log('series:', series);
				this.ChartAno.series = series;
			},
			configurarGraficos () {	
				this.configurarGraficoSexo();
				// this.configurarGraficoIdade();
				this.configurarGraficoAno();
			},
			pesquisar () {
				this.Pesquisa.estado = 1;

				this.$http.get(process.env.VUE_APP_API_ROOT + '/pesquisa-alunos' + this.QueryPesquisa).then(function(data){
                    return data.json();
                }).then(function(data){
                    // console.log(data);
                    this.Pesquisa.Resultados = data;
				
					this.Pesquisa.DadosAgregados = this.obterDadosAgregados();
					// console.log(this.Pesquisa.DadosAgregados);

					this.configurarGraficos();

					this.Pesquisa.estado = 2;
                }, response => { // error callback
					this.Pesquisa.estado = 2;
				});
			},
			limpar () {
				this.Pesquisa.Criterios = {
					ano_lectivo: StaticData.AnoLectivoActual
				};
				if (this.Concelhos.length === 1) {
					this.Pesquisa.Criterios.concelho_id = this.Concelhos[0].value;
				};
				this.Pesquisa.estado = 0;
				this.Pesquisa.Resultados = [];
			}
		}
	}
</script>


<style lang="scss" scoped>
	#chart-escola-ano {
		max-width: 800px;
		margin: 20px auto;
	}
</style>